// import React from 'react';

export class PreAppendTableContent {
    headerKey: string;
    value: any;
    position: number;
    // style?: React.CSSProperties;
    textAlign?: 'left' | 'center' | 'right';
}
